//@flow
import {isValidPhoneNumber} from 'libphonenumber-js';

import type {Conversation, ConversationResponse} from '../../../../entities';

export function conversationAdapter(
  conversationResponse: ConversationResponse
): Conversation {
  const {
    lastMessageType,
    lastMessageAt,
    lastMessage,
    ...rest
  } = conversationResponse;

  const contactInformation = rest.contactInformation;

  try {
    if (rest.ravenService === 'WHATSAPP_API') {
      const hasPhone = contactInformation?.phone ?? '';

      if (!isValidPhoneNumber(hasPhone)) {
        const identifier = rest?.identifier ?? '';
        const withCountryCode = identifier.startsWith('+')
          ? identifier
          : `+${identifier}`;
        const isValid = isValidPhoneNumber(withCountryCode);

        if (isValid) {
          const withoutCountryCode = identifier.replace('+', '');
          contactInformation.phone = withoutCountryCode;
        }
      }
    }
  } catch (error) {
    console.log(error);
  }

  return {
    ...rest,
    lastMessage,
    lastMessageAt,
    lastMessageType,
    contactInformation,
  };
}
